module.exports = __webpack_public_path__ + "img/AMS-logo.ece199bd.png";